import { Chip } from '@mui/material';
import { dateFormats, formatDateTime } from '../../shared/utils';

const statuses = {
  isReadyToProcess: { label: 'Shipping', color: 'primary' },
  isAvailableDateTbd: { label: 'TBD', color: 'secondary' },
  isWaitingOnStock: { label: 'Waiting on Stock', color: 'warning' },
  isPastDue: { label: 'Past due', color: 'error' },
  isAvailableToShipNow: { label: 'Available to ship', color: 'success' },
};

export const TransactionStatus = ({ transaction }) => {
  const status =
    (transaction.isReadyToProcess && statuses.isReadyToProcess) ||
    (transaction.isAvailableDateTbd && statuses.isAvailableDateTbd) ||
    (transaction.isWaitingOnStock && statuses.isWaitingOnStock) ||
    (transaction.isPastDue && statuses.isPastDue) ||
    (transaction.isAvailableToShipNow && statuses.isAvailableToShipNow);

  if (
    status.label === statuses.isWaitingOnStock.label &&
    transaction.earliestShipDate
  ) {
    status.label = `Avail: ${formatDateTime(
      transaction.earliestShipDate,
      dateFormats.short
    )}`;
  }

  return status && <Chip size='small' sx={{ fontSize: 12 }} {...status} />;
};
